import { render, staticRenderFns } from "./DetailRichText.vue?vue&type=template&id=b6cf2ef0&scoped=true&lang=pug&"
import script from "./DetailRichText.vue?vue&type=script&lang=js&"
export * from "./DetailRichText.vue?vue&type=script&lang=js&"
import style0 from "./DetailRichText.vue?vue&type=style&index=0&id=b6cf2ef0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cf2ef0",
  null
  
)

export default component.exports